import { EventOptions, TrackingEvents } from '@estercare/ester-shared'
import { useEventMutation } from '../../api/ester-b2b-api/private/event/eventQueries'
import { useLocation } from 'react-router-dom'
import { queryErrorHandler } from '../../utils/queryErrorHandler'
import { useCallback } from 'react'

export const useEmitEvent = () => {
  const mutation = useEventMutation()
  const location = useLocation()
  return useCallback(
    ({
      eventType,
      eventPage,
      action,
      options,
    }: {
      eventType: TrackingEvents
      eventPage?: string
      action?: string
      options?: EventOptions
    }) => {
      const eventId = crypto.randomUUID()
      const updatedOptions: EventOptions = {
        metadata: {
          ...(action && { action }),
          ...options?.metadata,
        },
      }
      if (!eventPage) {
        eventPage = location.pathname
      }
      void mutation.mutate(
        { eventId, eventType, eventPage, options: updatedOptions },
        {
          onError: (error) => {
            queryErrorHandler('send tracking event')(error)
          },
        }
      )
    },
    [mutation, location]
  )
}
